/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo } from 'react'
import { displayDollars } from '../../../helpers/displayFormatHelper'

interface Option {
  name: string
  price: number
}

interface Products<
  T extends Record<string, any>,
  K extends Record<string, any>
> {
  name: string
  options: T[]
}

interface ProductsBreakdownProps {
  products: Products<Option, { [key: string]: any }>[]
  getTotal: (total: number) => void
  downPayment: number
  basePrice: number
  status: void
  validationDiscountMax: number
}

export function ProductsBreakdown({
  products,
  getTotal,
  downPayment,
  basePrice,
  validationDiscountMax,
  status
}: ProductsBreakdownProps) {
  const sumTotal = useMemo(() => {
    const options = products.map((product) =>
      product.options.map(
        (option) => option.price?.toString() || "no price found"
      )
    );

    const newAmount = options
      .map((option) => option.reduce((acc, o) => Number(acc) + Number(o), 0))
      .reduce((acc, opt) => acc + opt, 0);

    // const previousAmount = basePrice;
    // const discountAmount = validationDiscountMax;
    // const difference = newAmount - previousAmount;

    // const isPaid = status?.code === "payment_succeeded";
    // if (isPaid) {
    //   const noChangeRequired =
    //     newAmount <= previousAmount || difference <= discountAmount;

    //   if (noChangeRequired) {
    //     newAmount = previousAmount;
    //   } else {
    //     newAmount -= downPayment;
    //   }
    // }
    return newAmount;
  }, [products, status, basePrice, downPayment]);

  useEffect(() => {
    getTotal(sumTotal)
  }, [getTotal, sumTotal])

  return (
    <div className="refi-payment-options__products-container">
      {products.map((product, index) => {
        return (
          <div key={index}>
            <span className="refi-payment-options__title-small">
              {product.name}
            </span>
            <div>
              {product.options.map((option, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="refi-payment-options__option-container">
                      <span>{option.name}</span>
                      <span>{displayDollars(option.price)}</span>
                    </div>
                    <hr />
                  </React.Fragment>
                )
              })}
            </div>
          </div>
        )
      })}
      <div className="refi-payment-options__option-container">
        <span className="refi-payment-options__title-total">Total</span>
        <span>{displayDollars(sumTotal)}</span>
      </div>
    </div>
  )
}

export default ProductsBreakdown
